import { render } from "./NotificationConfirmPage.vue?vue&type=template&id=669635aa&scoped=true"
import script from "./NotificationConfirmPage.vue?vue&type=script&lang=js"
export * from "./NotificationConfirmPage.vue?vue&type=script&lang=js"

import "./NotificationConfirmPage.vue?vue&type=style&index=0&id=669635aa&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-669635aa"]])

export default __exports__